import type { IndexRouteObject, RouteObject } from "react-router-dom";
import App from "./App";
import { environment } from "./environment";
import {
  DeviceActivity,
  // SigningIn,
} from "@keycloak/keycloak-account-ui";
import { CustomApplications } from './content/CustomApplications';
import { SigningIn } from "./content/SigningIn";

export type ExtendedRoute = (IndexRouteObject | RouteObject) & { label: string };


export const DeviceActivityRoute: ExtendedRoute = {
  path: "account-security/deviceActivity",
  element: <DeviceActivity />,
  label: "deviceActivity"
};

export const SigningInRoute: ExtendedRoute = {
  path: "account-security/signingIn",
  element: <SigningIn />,
  label: "signingIn"
};

export const ApplicationsRoute: ExtendedRoute = {
  index: true,
  path: "",
  element: <CustomApplications />,
  label: "applications"
};


export const RootRoute: RouteObject = {
  path: decodeURIComponent(new URL(environment.baseUrl).pathname),
  element: <App />,
  errorElement: <>Error</>,
  children: [
    ApplicationsRoute,
    SigningInRoute,
    DeviceActivityRoute,
  ],
};

export const routes: RouteObject[] = [RootRoute];
